// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"d553170b","61":"2de7ed98","280":"b7bfaa0e","319":"4288e963","354":"c9292d7c","384":"91bae345","453":"e149cb9f","517":"1fb7b610","531":"808fd63c","677":"96c2ef3a"}[chunkId] + ".chunk.js";
};